import { useState } from "react";
import { SpeedInsights } from '@vercel/speed-insights/react';
import IntroOverlay from "./components/IntroOverlay";
import Navbar from "./components/NavBar";
import MobileNavBar from "./components/MobileNavBar";
import CTA from "./components/CTA";
import Hero from "./sections/Hero";
import ShowcaseSection from "./sections/ShowcaseSection";
import LogoShowcase from "./sections/LogoShowcase";
import FeatureCards from "./sections/FeatureCards";
import Experience from "./sections/Experience";
import TechStack from "./sections/TechStack";
import Contact from "./sections/Contact";
import Footer from "./sections/Footer";
import SwapCards from "./sections/SwapCards";
import ScrollText from "./sections/ScrollText";
import ClickSpark from './blocks/Animations/ClickSpark/ClickSpark';

const App = () => {
  const [introDone, setIntroDone] = useState(false);

  return (
    <>
      {!introDone && <IntroOverlay onFinish={() => setIntroDone(true)} />}

      {introDone && (
        <div className="fade-in">
          <ClickSpark sparkColor='#fff' sparkSize={10} sparkRadius={15} sparkCount={8} duration={400}>
            <Navbar />
            <MobileNavBar />
            <Hero />
            <ShowcaseSection />
            <CTA text="Un projet ?" />
            <LogoShowcase />
            <FeatureCards />
            <ScrollText />
            <SwapCards />
            <Experience />
            <TechStack />
            <Contact />
            <Footer />
          </ClickSpark>
        </div>
      )}
      <SpeedInsights />
    </>
  );
};

export default App;
